import { SIZE } from 'models/Size';

export const PORTFOLIO_CARDS_SIZE = {
  [SIZE.SMALL]: {
    desktop: 230,
    mobile: 466,
  },
  [SIZE.BIG]: {
    desktop: 350,
    mobile: 575,
  },
};
